import { Condition, Operand, ParameterItem } from 'app/shared/models';

function getValue(operand: Operand, parameters: ParameterItem[]): string {
  if (operand.source === 'Parameter') {
    const param = parameters.find((p) => operand.field === p.name);
    return param ? param.value : null;
  } else if (operand.source === 'Const') {
    return operand.value;
  }

  return null;
}

/** Evaluates a condition built from Parameter and Const operands against the user's parameters. */
export function evaluateParameterCondition(
  condition: Condition,
  parameters: ParameterItem[],
): boolean {
  if (condition.logic) {
    const children = condition.conditions.map((c) => evaluateParameterCondition(c, parameters));
    if (condition.logic === 'And') {
      return children.every((c) => c);
    } else {
      return children.some((c) => c);
    }
  } else {
    const operand1Value = getValue(condition.operand1, parameters);
    const operand2Value = getValue(condition.operand2, parameters);
    return evaluateOperands(operand1Value, condition.operator, operand2Value);
  }
}

function evaluateOperands(op1: string, operator: string, op2: string): boolean {
  if (operator === 'Eq') {
    if (op1 === null || op2 === null) {
      return op1 === 'null' || op2 === 'null';
    }
    return op1 === op2;
  } else if (operator === 'Neq') {
    return op1 !== op2;
  } else if (op1 === null || op2 === null) {
    return false;
  } else if (operator === 'Lt') {
    return +op1 < +op2;
  } else if (operator === 'Lte') {
    return +op1 <= +op2;
  } else if (operator === 'Gt') {
    return +op1 > +op2;
  } else if (operator === 'Gte') {
    return +op1 >= +op2;
  }
  return false;
}
